// extracted by css-extract-rspack-plugin
export default {"root":"root-28VWR","standard":"standard-23uZA","narrow":"narrow-qAadb","wide":"wide-3NC9g","full":"full-2G2L0"};